import {useMemo} from 'react';

import {useSelector} from 'react-redux';
import styled from 'styled-components';

import {
  selectAllAddresses,
  selectCurrentAddressKey,
  selectSearchMode,
} from '~/shared/store/selectors';
import {findAddressByAddressKey} from '~/shared/utils/address';
import AddressText from '~/shared/components/AddressDropdown/ButtonText';
import AddressDropdownComponent from '~/common/components/AddressDropdown';
import {useIsIOS, useIsMaxMobile} from '~/shared/hooks/deviceInfo';
import {scrollToTop} from '~/shared/utils/scroll';
import {flexCenter} from '~/shared/theme/FlexLayout';
import AddressIcon from '~/assets/images/icons/location-icon.svg?react';
import {flipOnLTR} from '~/shared/theme/flipOnLTR';

const AddressWrapper = styled.div`
  ${flexCenter}
`;

const StyledAddressIcon = styled(AddressIcon)`
  ${flipOnLTR`
    margin-left: 4px;
  `}
`;

const AddressDropdown = ({
  readOnlyAddress,
  scrollTopOnOpenAddressDropdown,
  isMenuPage,
}: {
  readOnlyAddress?: boolean;
  scrollTopOnOpenAddressDropdown?: boolean;
  isMenuPage: boolean;
}) => {
  const initialAddresses = useSelector(selectAllAddresses);
  const addressKey = useSelector(selectCurrentAddressKey);
  const searchMode = useSelector(selectSearchMode);

  const isMaxMobile = useIsMaxMobile();
  const isIos = useIsIOS();

  const hideAddressDropdown = useMemo(() => searchMode && isMaxMobile, [isMaxMobile, searchMode]);

  const activeAddress = useMemo(
    () => findAddressByAddressKey(initialAddresses, addressKey),
    [addressKey, initialAddresses],
  );

  const onAddressDropdownOpen = () => {
    if (!scrollTopOnOpenAddressDropdown) {
      return;
    }

    scrollToTop(isIos);
  };

  if (hideAddressDropdown) {
    return null;
  }

  if (readOnlyAddress) {
    return (
      <AddressWrapper>
        <StyledAddressIcon />
        <AddressText activeAddress={activeAddress} isAddingFirstAddress={false} />
      </AddressWrapper>
    );
  }

  return <AddressDropdownComponent onOpen={onAddressDropdownOpen} isMenuPage={isMenuPage} />;
};

export default AddressDropdown;
